export default __webpack_public_path__ + "static/media/bg-login.7c951fd2.png";